// extracted by mini-css-extract-plugin
export default {"timeAgo":"_2IcFr"};